import { gql } from 'apollo-boost';

export const EXTRACT_URL_MEDIA = gql`
    mutation($data: ExtractUrlMediaInput!) {
        extractUrlMedia(data: $data) {
            url
            name
            displayName
            type
            format
            size
            mime
        }
    }
`;
